@if (isLoading) {
<div class="loading-overlay">
    <p-progressSpinner styleClass="custom-spinner" strokeWidth="3" fill="white" animationDuration="1.5s"></p-progressSpinner>
</div>
}